// i18n area 'networks' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.lt-LT.meta.json.
import type { enUS } from './networks'

export const ltLT: typeof enUS = {
  networks: {
    common: {
      name: 'Pavadinimas',
      scope: 'Scope',
      operState: 'Būsena',
      actions: 'Veiksmai',
      create: 'Kurti',
      close: 'Uždaryti',
      cancel: 'Atšaukti',
      delete: 'Ištrinti',
      edit: 'Redaguoti',
      save: 'Įrašyti',
      editError: 'Redaguoti nepavyko',
      search: 'Ieškoti pagal pavadinimą',
      empty: 'Čia dar nieko nėra',
      saveError: 'Nepavyko įrašyti',
      loadError: 'Nepavyko įkelti — ar TVirt backend pasiekiamas?',
      createError: 'Sukurti nepavyko',
      deleteError: 'Ištrinti nepavyko',
      deleteConfirmTitle: 'Ištrinti {name}?',
      deleteConfirmBody: 'Šis veiksmas negrįžtamas.',
      nameHint: 'Mažosios raidės, skaitmenys ir brūkšneliai (DNS-1123)',
      up: 'Aktyvus',
      down: 'Neaktyvus',
      unknown: 'Nežinoma',
      usedByVMs: 'VM',
      emptyTable: 'Įrašų nėra — pridėkite vieną mygtuku +'
    },
    dialogTabs: {
      general: 'Bendra',
      base: 'Bazinis apibrėžimas',
      advanced: 'Išplėstinė konfigūracija',
      reserved: 'TVirt rezervuoti diapazonai',
      position: 'Padėtis',
      network: 'Tinklo konfigūracija',
      hosts: 'Dalyvaujantys mazgai'
    },
    reservedRanges: {
      note: 'Tai TVirt rezervuoti IP diapazonai, kuriuos jis gali naudoti adresui automatiškai priskirti VM, konteineriams ir pan. PASTABA: šių diapazonų IP adresų už TVirt ribų neturi naudoti išorinės paslaugos ar įrenginiai.',
      from: 'Nuo',
      to: 'Iki'
    },
    overlay: {
      title: 'Overlay tinklai',
      createTitle: 'Kurti overlay tinklą',
      editTitle: 'Redaguoti overlay tinklą',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — priskiriamas automatiškai, jei paliekama tuščia',
      subnet: 'Potinklis',
      subnetHint: 'Overlay CIDR — IPAM iš jo automatiškai išveda registro įrašą',
      mtu: 'MTU',
      weight: 'Svoris',
      ceilMbps: 'Lubos (Mbps)',
      fairnessHint: 'Svoris galioja tik esant konkurencijai: laisva jungtimi kiekvienas tinklas gali naudoti visą pralaidumą. Lubos galioja visada.',
      contention: 'Konkurencija',
      contentionTip: 'Bent vienas mazgas šio tinklo klasėje mato atmetimus ar overlimit SU eile: uplink pralaidumas yra ginčijamas ir svoriai veikia. Kiek ir nuo kada — mazgo net.shaping.* serijose.',
      firewallPolicy: 'Firewall politika',
      hosts: 'Hostai',
      hostsTitle: 'Dalyvaujantys mazgai',
      hostsHint: 'Kiekvienas mazgas deklaruoja savo underlay endpoint — renkamasi iš TIKRŲ mazgo adresų, nuskaitytų iš jo tinklo konfigūracijos; neprivalomas overlay adresas turi patekti į potinklį. Dalyvavimas yra placement apribojimas.',
      hostNode: 'Mazgas',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Pirma pasirinkite mazgą',
      hostAddress: 'Adresas overlay tinkle (neprivaloma)',
      hostAddressOutside: 'Už overlay potinklio ribų ({cidr})',
      addHost: 'Pridėti mazgą',

      // Round #156 (standartinis dialogas): stebimos detalių dialogo eilutės.
      observedAt: 'Stebėta',
      attachedNics: 'Prijungtos NIC'
    },
    services: {
      title: 'Tinklo paslaugos',
      createTitle: 'Kurti tinklo paslaugą',
      editTitle: 'Redaguoti tinklo paslaugą',
      kind: 'Tipas',
      kindCategory: 'Paslaugos',
      selectKindHint: 'Pasirinkite paslaugos tipą — kuris demonas veikia po ja, yra realizacijos detalė, kurią TVirt tvarko už jus.',
      kindLabel: {
        dhcp: 'DHCP serveris',
        ntp: 'NTP serveris',
        vpn: 'VPN serveris',
        dns: 'DNS serveris',
        gateway: 'Gateway',
        'lb-rp': 'Apkrovos balansuoklis ir reverse proxy',
        floatip: 'Plaukiojantis IP'
      },
      kindDesc: {
        dhcp: 'Priskiria adresus aptarnaujamuose potinkliuose — telkiniai išvedami iš tinklo potinklio, gateway ir TVirt rezervuotų diapazonų.',
        dns: 'Autoritetingas DNS deklaruotose zonose — įrašai išvedami iš IPAM ir papildomi jūsų rankiniais.',
        gateway: 'Mazgas veikia kaip tinklo gateway — NAT (DNAT, 1:1, SNAT/masquerade) ir statinis maršrutizavimas tarp prijungtų tinklų, savaime atsistatantis pagal sumanymą.',
        'lb-rp': 'Apkrovos balansuotojas / atvirkštinis tarpinis serveris prieš jūsų paslaugas — L4 arba L7 klausytojai virš narių telkinių arba virš parengtų Pod egzempliorių, perkonfigūruojami veikimo metu.',
        ntp: 'Tinklų laiko paslauga — išorinių upstream serverių relay arba aptarnaujančio mazgo laikrodis, teikiamas klientams.',
        vpn: 'VPN koncentratorius mazge — WireGuard arba OpenVPN, renkatės jūs: nuotolinė prieiga keliaujantiems klientams arba site to site tunelis tarp dviejų tinklų.',
        floatip: 'Vienas adresas, kuris vienu metu yra tik ant vieno sveiko App egzemplioriaus ar Pod ir, jam kritus, pereina prie kito sveiko taikinio — failover be demonų; balansavimas lieka balansuotojui.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Plaukiojantis IP gyvena pasirinktame tinkle kaip PAPILDOMAS adresas laikančiojo egzemplioriaus vardų erdvėje: be prievadų, be balansavimo, be NAT — kliento IP lieka tikras.',
        address: 'Plaukiojantis IP',
        targets: 'Taikiniai',
        targetsHint: 'PIRMENYBĖS tvarka: pirmasis sveikas taikinys laiko adresą. Pod reiškia visus jo egzempliorius pagal repliką; kiekvienas taikinys turi savo sveikatos kriterijų. Kiekvienas taikinys turi būti prijungtas prie to paties tinklo.',
        targetKind: 'Taikinys',
        targetApp: 'App egzempliorius',
        targetPod: 'Pod (visi egzemplioriai)',
        targetRef: 'Kuris',
        health: 'Sveikata',
        healthRunning: 'Veikia (kiekvienas konteineris parengtas)',
        healthTcp: 'TCP ryšys',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Prievadas',
        path: 'Kelias',
        addTarget: 'Pridėti taikinį',
        moveUp: 'Perkelti aukštyn',
        moveDown: 'Perkelti žemyn',
        preempt: 'Preempt',
        preemptHint: 'Išjungta (numatyta): sveikas laikytojas išlaiko adresą net grįžus aukštesniam taikiniui — jokio blaškymosi. Įjungta: pirmasis sveikas taikinys visada jį laiko.',
        holder: 'Laikytojas',
        noHolder: 'nėra sveiko taikinio',
        since: 'nuo',
        verdicts: 'Stebimi taikiniai',
        healthy: 'sveikas',
        unhealthy: 'nesveikas',
        noVerdict: 'Dar nenuspręsta — autoritetinis mazgas įrašo pirmą verdiktą per kitą savo ėjimą.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Šis egzempliorius laiko paslaugos {service} plaukiojantį IP {address}'
      },
      poolSource: 'Galiniai taškai',
      poolSourceMembers: 'Statiniai nariai',
      poolSourcePod: 'Parengti Pod egzemplioriai',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Prievadas',
      poolBackendHint: 'Galiniai taškai seka Pod: egzempliorius įtraukiamas, kai veikia su kiekvienu parengtu konteineriu, ir iškart pašalinamas, kai sumažinamas ar miršta. Aktyvus tikrinimas numatytai įjungtas.',
      poolBackendCount: 'Pod {pod} parengti egzemplioriai prievade {port}',
      node: 'Mazgas',
      enabled: 'Įjungta',
      parked: 'Pastatyta',
      subnets: 'Potinkliai',
      subnetsHint: 'Šio egzemplioriaus aptarnaujami IPAM potinkliai — telkiniai išvedami iš CIDR, gateway ir TVirt rezervuotų diapazonų',
      noSubnets: 'IPAM potinklių nėra — pirma deklaruokite loginį fabric tinklą (arba overlay potinklį): IPAM išvedamas iš jų',
      iface: 'Klausymo sąsaja',
      ifaceHint: 'Pagrindinio kompiuterio sąsaja, kurioje paslauga atidaro savo lizdą (pvz., tiltas) — privaloma: tinklo paslauga yra savarankiška, „visos sąsajos" nebeegzistuoja',
      dns: 'DNS serveriai',
      domain: 'Domenas',
      detail: 'Aptarnauja',
      subnetCount: 'potinklių: {n}',
      zones: 'Zonos',
      zonesHint: 'Tik autoritetingas — demonas niekada nesikreipia rekursyviai. A įrašai išvedami iš deklaruotų mazgų adresų nurodytuose IPAM potinkliuose; reverse jungiklis papildomai aptarnauja atitinkamas in-addr.arpa zonas (PTR). Vieną zoną visame parke aptarnauja daugiausia vienas DNS egzempliorius. Neprivalomas nameserver yra FQDN, įrašomas į NS/SOA įrašus vietoj numatytojo ns.<zona>; jei jis patenka į pačią zoną, jo A įrašas vis tiek išvedamas iš aptarnaujančio mazgo.',
      zoneName: 'Zonos pavadinimas',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM potinkliai',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Rankiniai įrašai',
      zoneRecordsHint: 'Po vieną eilutėje: vardas TIPAS reikšmė — tipai A, CNAME, MX, TXT. Susidūrus vardams, rankinis įrašas nugali išvestąjį.',
      addZone: 'Pridėti zoną',

      // lb-rp (3 bangos pamatai): listeneriai virš inline telkinių — be atskiro
      // variklio, perkonfigūruojami skrydžio metu.
      lbListeningHint: 'Egzempliorius deklaruoja VIENĄ klausymo tinklą ir VIENĄ adresą — kiekvienas klausytojas susieja jį savo prievade; antras adresas yra antra paslauga.',
      listeners: 'Listeneriai',
      listenersHint: 'Kiekvienas klausytojas susieja egzemplioriaus adresą savo prievade L4 režimu (TCP passthrough — baitai niekada neatidaromi) arba L7 (HTTP) ir persiunčia į vieną iš žemiau esančių telkinių. Adreso/prievado porą aptarnauja daugiausia vienas egzempliorius mazge. Pakeitimai taikomi skrydyje — be perkrovimo, be prarastų ryšių.',
      listenerName: 'Pavadinimas',
      listenerMode: 'Režimas',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Prievadas',
      listenerPool: 'Telkinys',
      addListener: 'Pridėti listenerį',
      pools: 'Telkiniai',
      poolsHint: 'Backend serveriai, į kuriuos nusileidžia srautas: statiniai nariai, balansuojami round-robin arba pagal mažiausiai užimtą, su neprivalomu aktyviu health check, kuris išima iš rotacijos sergančius narius.',
      poolName: 'Pavadinimas',
      poolAlgorithm: 'Algoritmas',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Mažiausiai užimtas',
      poolCheck: 'Health check',
      checkNone: 'Nėra',
      checkTcp: 'TCP jungtis',
      checkHttp: 'HTTP',
      poolCheckPath: 'Zondo kelias',
      poolInterval: 'Intervalas (s)',
      poolMembers: 'Nariai',
      poolMembersHint: 'Po vieną eilutėje: adresas:prievadas, neprivalomai su svoriu (1-128) — pvz., 10.0.0.21:8080 2',
      addPool: 'Pridėti telkinį',
      memberCount: 'narių: {n}',

      // ntp (ntp round — ratifikuota 2026-08-03, paskutinis šeimos kind):
      // režimas šnekamais žodžiais, upstream sąrašas tik ten, kur jis ką nors
      // reiškia, tinklo prijungimas perima gateway etiketes.
      listen: {
        assignment: 'Priskyrimas',
        assignmentStatic: 'Statinis adresas',
        assignmentAuto: 'Automatinis (TVirt rezervuoti diapazonai)',
        autoHint: 'TVirt ištraukia adresą iš loginio tinklo rezervuotų diapazonų ir laiko jį sticky — niekada netraukiamas iš naujo redaguojant ar failover metu.',
        title: 'Klausytojai',
        hint: 'Tinklo paslauga yra savarankiška: kiekvienas klausytojas deklaruoja savo tinklą (overlay, loginį fabric tinklą ar gryną sąsają) ir adresą jo potinklyje — vienas klausytojas adresui, pakaitos simbolio nebėra. DNS ir NTP gali klausytis keliuose tinkluose ir keliais tų tinklų adresais.',
        address: 'Klausymo adresas',
        add: 'Pridėti klausytoją'
      },
      ntp: {
        mode: 'Sinchronizavimo režimas',
        modeRelay: 'Išorinių serverių relay',
        modeNodeClock: 'Mazgo laikrodis',
        modeHint: 'Relay teikia laiką, paimtą iš deklaruotų upstream serverių; mazgo laikrodis teikia aptarnaujančio mazgo laiką — kurį klasteris šiaip ar taip laiko sinchronizuotą',
        servers: 'Upstream serveriai',
        serversHint: 'Atskirti kableliais — hostname arba IP adresas; paslauga ima laiką iš čia ir teikia jį tinklui',
        port: 'Klausymo prievadas',
        listening: 'Klausosi'
      },

      vpn: {
        engine: 'Variklis',
        engineHint: 'Renkatės jūs, ir vėliau tai nebekeičiama: WireGuard yra modernus, greitas ir veikia branduolyje; OpenVPN yra suderinamumo veteranas (TCP, priešiški tinklai)',
        engineLocked: 'Variklis nekeičiamas — kitas variklis reiškia naują paslaugą, raktai ir sertifikatai neperkeliami',
        mode: 'Režimas',
        modeRemote: 'Nuotolinė prieiga',
        modeSite: 'Site to site',
        modeHint: 'Nuotolinė prieiga suteikia keliaujantiems klientams adresą tunelyje; site to site sujungia du tinklus',
        port: 'Klausymo prievadas',
        protocol: 'Transportas',
        protocolWireguardHint: 'WireGuard kalba tik UDP',
        tunnelSubnet: 'Tunelio potinklis',
        tunnelSubnetHint: 'Tinklas, kuriame gyvena klientai — užregistruotas IPAM registre, gimsta ir miršta kartu su šia paslauga',
        dnsServers: 'Klientams perduodami DNS',
        routes: 'Klientams perduodami maršrutai',
        routesHint: 'Kableliais atskirti tinklai, pasiekiami tuneliu; tunelio potinklis visada įtraukiamas',
        peers: 'Peerai',
        peersHint: 'Palikite viešąjį raktą tuščią ir TVirt sugeneruos porą — o paskui pateiks ją kartu su profiliu. Įklijuokite raktą ir peeras pasiliks savąjį.',
        clients: 'Klientai',
        clientsHint: 'Kiekvienas klientas gauna šios paslaugos CA išduotą sertifikatą. Kliento pašalinimas jį PANAIKINA: CRL iškart sugeneruojamas iš naujo.',
        peerName: 'Pavadinimas',
        publicKey: 'Viešasis raktas',
        publicKeyMinted: 'Sugeneruos TVirt',
        peerAddress: 'Adresas tunelyje',
        peerAddressHint: 'Tuščia = priskiriamas',
        allowedIps: 'Nutolę potinkliai',
        allowedIpsHint: 'Atskirti kableliais, maršrutizuojami per šį peerą',
        endpoint: 'Endpoint',
        presharedKey: 'Iš anksto bendrintas raktas',
        keepalive: 'Keepalive (s)',
        addPeer: 'Pridėti peerą',
        addClient: 'Pridėti klientą',
        auth: 'Tapatumo nustatymas',
        authTls: 'Sertifikatai (TLS)',
        remote: 'Nutolęs endpoint',
        remoteHint: 'nutolusio galo host:prievadas — tuščia reiškia, kad ši pusė laukia',
        peerRoutes: 'Nutolę potinkliai',
        serverPublicKey: 'Šio serverio viešasis raktas',
        ca: 'Sertifikavimo įstaiga',
        listening: 'Klausosi',
        tunnel: 'Tunelis',
        peerCount: 'peerų: {n}',
        download: 'Atsisiųsti profilį',
        downloadError: 'Nepavyko eksportuoti profilio',
        lastHandshake: 'Paskutinis handshake',
        never: 'niekada',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Prisijungęs',
        idle: 'Neaktyvus'
      },

      // Gateway (3 banga — gimė kaip nat, ratifikuota 2026-08-01/02;
      // pervadintas ir išplėstas 2026-08-03): trys NAT taisyklių šeimos plius
      // statiniai maršrutai klausymo tinkle. Palaikoma kiekviena ratifikuota forma.
      gateway: {
        attach: 'Klausymo tinklo tipas',
        attachOverlay: 'Overlay tinklas',
        attachNetwork: 'Loginis fabric tinklas',
        attachInterface: 'Neapdorota sąsaja',
        overlay: 'Overlay tinklas',
        network: 'Loginis tinklas',
        interface: 'Sąsajos pavadinimas',
        interfaceHint: 'Hosto sąsaja, kurios TVirt nevaldo — adresas priimamas kaip yra',
        address: 'Klausymo adresas (gateway)',
        addressHint: 'Gateway adresas, į kurį rodo klientai — klausymo tinklo potinklyje',
        dnatTitle: 'DNAT taisyklės',
        dnatHint: 'Paskirties NAT: atitikęs srautas nukreipiamas į naują adresą (ir, neprivalomai, į naują prievadą). Bet kuris sąrašo protokolas — prievadai ten, kur protokolas juos turi.',
        snatTitle: 'SNAT taisyklės',
        snatHint: 'Šaltinio NAT: atitikęs srautas išeina su perrašytu šaltiniu — nauju aiškiai nurodytu adresu (ir, neprivalomai, nauju prievadu) arba masquerade su išėjimo adresu, jei palikta tuščia.',
        oneToOneTitle: '1:1 NAT taisyklės',
        oneToOneHint: 'Kiekvienas išoriniam adresui skirtas paketas atvaizduojamas į vidinį, o vidinis hostas išeina kaip išorinis — visi protokolai, abi kryptys.',
        external: 'Išorinis adresas',
        internal: 'Vidinis adresas',
        addOneToOne: 'Pridėti 1:1 taisyklę',
        family: 'Šeima',
        protocol: 'Protokolas',
        source: 'Šaltinis (adresas/potinklis)',
        destination: 'Paskirtis (adresas/potinklis)',
        invert: 'NOT',
        srcPorts: 'Šaltinio prievadai',
        dstPorts: 'Paskirties priev.',
        dstPortsHint: 'Prievadas arba diapazonas (80, 8000-8099)',
        toAddress: 'Naujas adresas',
        toPort: 'Naujas prievadas',
        snatTo: 'Naujas šaltinis (tuščia = masquerade)',
        snatToHint: 'Aiškiai nurodytas šaltinio adresas; tuščia = masquerade su išėjimo adresu',
        addDnat: 'Pridėti DNAT taisyklę',
        addSnat: 'Pridėti SNAT taisyklę',
        routesTitle: 'Statiniai maršrutai',
        routesHint: 'Mazgas maršrutizuoja tarp tinklų, prie kurių prijungtas (IP forwarding įjungtas); šie maršrutai prideda pasiekiamumo virš jų — grynas branduolys, dinaminis maršrutizavimas atkeliaus vėlesniame etape.',
        routeDestination: 'Paskirties potinklis',
        routeGateway: 'Next hop',
        routeMetric: 'Metrika',
        addRoute: 'Pridėti maršrutą',
        listening: 'Klausosi',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} maršrutai'
      },
      unknownSince: 'Nežinoma — paskutinis pranešimas prieš {m} min.',
      lastWord: 'Paskutinis žodis',

      // Round #156 (standartinis dialogas): stebimos eilutės ir tik skaitomas
      // kind bloko suvestinis vaizdas detalių dialoge.
      reportObservedAt: 'Paskutinis pranešimas',
      lastErrorRow: 'Paskutinė klaida',
      recordsCount: 'rankinių įrašų: {n}',
      phase: {
        configured: 'Sukonfigūruota',
        running: 'Vykdoma',
        error: 'Klaida'
      },
      authorityNode: 'Authority (priskyrimas)',
      preferredNode: 'Pageidaujamas mazgas',
      preferredNodeHint: 'Švelnus pageidavimas, niekada ne apribojimas: per kitą placement sprendimą egzempliorius nusileidžia čia, jei šis narys tinkamas — pats savaime jis nieko neperkelia; ėjimas yra „Perduoti authority“.',
      noPreference: 'Jokio pageidavimo (automatinis placement)',
      moving: 'Juda',
      movingTooltip: 'Stebima čia, kol authority priskiria {node}: perkėlimas kaip tik konverguoja.',
      placement: {
        title: 'Placement',
        loading: 'Vyksta surašymas…',
        loadError: 'Placement surašymas neatsakė — bandykite vėliau.',
        draftHint: 'Surašymas skaičiuojamas iš deklaruoto tinklo prijungimo: jis pasirodys, kai tik paslauga bus sukurta. Kūrimas atmetamas, kai joks narys negali jos aptarnauti, o atmetimas įvardija aibę ištuštinusį mechanizmą.',
        eligibleCount: '{n} iš {m} narių gali aptarnauti šį egzempliorių',
        recommended: 'Rekomenduojamas',
        eligible: 'Tinkamas',
        notEligible: 'Netinkamas',
        blockedReachability: 'tinklas šio nario nepasiekia',
        blockedRequireTag: 'užblokuotas privalomos žymos (requireNodes)',
        blockedExcluded: 'simuliacijos pašalintas',
        preferenceUnknown: 'nėra (nebe) klasterio narys',
        preferenceIgnored: 'Pageidavimas „{node}“ šiandien netinkamas: {reason}. Viršų ima surašymo rekomendacija — niekada ne klaida, paslauga gyvena kitur.',
        emptyReachability: 'Joks narys negali aptarnauti šio egzemplioriaus: tinklas nepasiekia niekur — joks žymų taisymas nepadės. Prijunkite mazgą kabeliu arba perkelkite paslaugą ten, kur tinklas yra.',
        emptyRequireTag: 'Joks narys negali aptarnauti šio egzemplioriaus: aibę ištuštino privalomos žymos — pašalinkite įrašą iš requireNodes arba pažymėkite kurį nors narį.',
        spof: 'Vienintelis gedimo taškas',
        spofDetail: 'Egzempliorių priglausti gali lygiai vienas narys: gedimo atveju failover neturi kur eiti. Kelių klausytojų paslauga keliasi kaip VIENETAS — kandidatas privalo matyti VISUS jos tinklus: tokia kaina.',
        whatIf: 'Simuliuoti nesančius narius',
        whatIfHint: 'Ištuštinimo „kas būtų, jeigu“: paklauskite PRIEŠ evakuaciją, o ne atraskite tai per failover.',
        survives: 'Be {nodes} paslauga vis dar turi namus.',
        notSurvives: 'Evakavus {nodes} ši paslauga lieka NEVEIKIANTI: išvestinis apribojimas nugali prieinamumą (R30) — demonas, gyvas ten, kur tinklas nepasiekia, niekam netarnauja ir nieko neįspėja.',
        transfer: 'Perduoti authority',
        transferError: 'Perdavimas nepavyko',
        transferTarget: 'Paskirties narys',
        transferHint: 'Siūlomi tik tinkami nariai — pageidavimas galiojančios aibės viduje, niekada ne override. Jokio task: kitas worker praėjimas IR YRA perkėlimas (senas mazgas nupjauna, naujas įkūnija).'
      }
    },
    fabric: {
      tabDerivation: 'Derivacija',
      importNetwork: 'Importuoti iš kito fabric',
      importTitle: 'Importuoti loginį tinklą',
      importHint: 'Importas yra aiškus prisijungimas: tinklas lieka savininko (ta pati tapatybė, tas pats stem, tas pats bridge tvf-<stem>) ir iš čia jis susiejamas su šio fabric prievadais/LAGG — susieti REIŠKIA tvirtinti, kad pristatymas išeina į tą patį L2 domeną kaip savininko.',
      importPick: 'Savininko tinklas',
      importNone: 'Nėra ko importuoti: kiti fabric neturi nuosavo tinklo, kurio šis fabric dar nežinotų',
      importedNetworksTitle: 'Importuoti tinklai',
      noImported: 'Importuotų tinklų nėra',
      importedFrom: 'importuota iš {fabric}',
      importedBy: 'Importavo: {list}',
      importedCount: '+{n} importuoti',
      owner: 'Savininkas',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Pašalinti importą',
      unimportConfirm: 'Pašalinti tinklo {name} (savininkas {fabric}) importą iš šio fabric? Atmetama, kol jį susieja šio fabric prievadas ar LAGG, arba svečias, App ar paslauga aptarnaujami tik per šią koją.',
      unimportRefused: 'Importas vis dar naudojamas — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Šis mazgas tą tinklą jau gauna iš kito fabric, kurio narys jis yra: mazgas bendrą tinklą ima tik per VIENĄ savo koją (du to paties L2 uplink bridge be STP yra kilpa). Atsiek jį viename iš dviejų fabric prievaduose arba LAGG.',
          otherFabricDerived: 'Dokumentas neša fabric bloką, į kurį mazgas nebedeklaruoja kabelio: pirma pritaikyk to fabric planą (jis siūlo pašalinti jo įrenginius) arba perimk juos su take-ownership, jei fabric nebėra.'
        },
        hint: 'O.3 derivacijos planas: kiekvienam prijungtam mazgui būsena, diff išvestas-vs-dabartinis, DEKLARUOTA bond topologija, dual-stack flipai ir struktūruoti atmetimai/įspėjimai. Tik skaitymui iki AIŠKAUS apply — niekas niekada nenusileidžia ant mazgo savaime.',
        refresh: 'Perkrauti planą',
        empty: 'Nė vienas mazgas neprijungtas prie šios fabric (ir nė vienas nebeturi jos bloko).',
        refusal: 'Atmetimas',
        warning: 'Įspėjimas',
        generation: 'dokumento karta {n}',
        state: {
          manual: 'Rankinis',
          derived: 'Išvestas',
          diverged: 'Nukrypęs'
        },
        topologyTitle: 'Deklaruota topologija',
        members: 'nariai',
        primary: 'pirminis',
        held: 'laikomas ant VIENO nario',
        form: {
          perNetworkBond: 'Bond kiekvienam tinklui',
          singleBond: 'Vienas atsarginis bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Vienas prievadas'
        },
        colAction: 'Veiksmas',
        colKind: 'Rūšis',
        colDevice: 'Device',
        colDetail: 'Detalė',
        action: {
          add: 'pridėti',
          remove: 'pašalinti',
          replace: 'pakeisti'
        },
        diffEmpty: 'Nėra laukiančio diff — pritaikytas dokumentas sutampa su renderiu.',
        diffBlocked: 'Nėra diff: aukščiau esantys atmetimai blokuoja šį mazgą.',
        phasePlanned: 'suplanuota (1 žingsnis iš 3)',
        phaseDraining: 'tuštinama (2 žingsnis iš 3)',
        probeUnobserved: 'Ištuštinimo zondas: niekada nepraneštas — tuštuma NEŽINOMA (retire dabar būtų atmestas).',
        probeFailed: 'Ištuštinimo zondas: stebėjimas NEPAVYKO — žinomos laiko žymos perkeliamos, niekada «tuščia», kurio niekas nematavo.',
        probeActive: {
          one: 'Zondas: {n} užmegztas ryšys vis dar senu adresu',
          few: 'Zondas: {n} užmegzti ryšiai vis dar senu adresu',
          many: 'Zondas: {n} užmegzto ryšio vis dar senu adresu',
          other: 'Zondas: {n} užmegztų ryšių vis dar senu adresu'
        },
        probeLastActive: 'paskutinis aktyvumas {time}',
        probeEmpty: {
          one: 'Zondas: tuščia {n} minutę',
          few: 'Zondas: tuščia {n} minutes',
          many: 'Zondas: tuščia {n} minutės',
          other: 'Zondas: tuščia {n} minučių'
        },
        probeEmptyUnknown: 'Zondas: tuščia (nuo kada — nežinoma).',
        impact: '{nics} vNIC ir {apps} App šiame mazge naudoja šiuos tinklus: {list}',
        apply: 'Taikyti šiam mazgui',
        applyTitle: 'Taikyti derivaciją — {node}',
        applyIntro: 'Išvesta konfigūracija perrašo mazgo {node} tinklo dokumentą ({n} pakeitimų) pro tas pačias duris kaip host-network redaktorius — įskaitant NetworkManager checkpoint ir sąžiningą zondą. Plano įspėjimai žemiau keliauja kartu su aktu: perskaitykite juos prieš patvirtindami.',
        applyError: 'Apply nepavyko',
        applyRefused: 'Mazgas atmetė:',
        planMoved: 'Fabric pasikeitė po šios peržiūros — NIEKO nebuvo pritaikyta. Planas perkrautas: pažiūrėkite dar kartą ir bandykite iš naujo.',
        retire: 'Išimti',
        retireTitle: 'Negrįžtamumo taškas — {address} išėmimas',
        restore: 'Atkurti',
        restoreTip: 'Grįžti į momentinę kopiją prieš apply (karta {previous}) — vieno žingsnio atšaukimas (H13)',
        restoreTitle: 'Atkurti ankstesnį dokumentą — {node}',
        restoreIntro: 'Mazgo {node} tinklo dokumentas grįžta į momentinę kopiją, padarytą prieš paskutinį apply (karta {previous}), perrašytą kaip karta {next} vietoj {current}. Worker jį suderina kaip bet kurį kitą dokumentą.',
        restoreRedo: 'Pakeistas dokumentas tampa nauja momentine kopija: atkūrimas dar kartą yra redo.',
        restoreClosesChain: 'Momentinė kopija yra rankinis dokumentas prieš išvedimą: grandinė čia užsidaro — daugiau atšaukimų nėra, mazgas lieka rankinis iki kito apply.',
        restoreConfirm: 'Atkurti',
        restoreError: 'Atkurti nepavyko',
        retireIntro: 'Tai galutinai pašalina {address} ({network}) iš {point}. Po šio akto kelias atgal yra ATVIRKŠTINIS flipas — iš naujo deklaruoti seną adresą per tą patį variklį — niekada aklas atkūrimas.',
        retireOld: 'Senas adresas (pašalintas)',
        retireNew: 'Naujas adresas (lieka)',
        retireEmptyFact: 'Ištuštinimo zondas praneša adresą tuščią: šis pašalinimas nenutraukia jokio stebėto ryšio.',
        retireConfirm: 'Išimti adresą',
        severActiveLoss: {
          one: 'Nutraukti {n} užmegztą ryšį vis dar senu adresu — jis miršta su šiuo aktu',
          few: 'Nutraukti {n} užmegztus ryšius vis dar senu adresu — jie miršta su šiuo aktu',
          many: 'Nutraukti {n} užmegzto ryšio vis dar senu adresu — jie miršta su šiuo aktu',
          other: 'Nutraukti {n} užmegztų ryšių vis dar senu adresu — jie miršta su šiuo aktu'
        },
        severUnknownLoss: 'Priimti NEŽINOMYBĘ: zondas niekada nestebėjo šio adreso (arba stebėjimas nepavyksta) — gyvi ryšiai gali būti nutraukti.'
      },
      title: 'Fabric',
      createTitle: 'Kurti fabric',
      networks: 'Tinklai',
      switches: 'Switchai',
      ports: 'Prievadai',
      laggs: 'LAGG',
      subnets: 'Potinkliai',
      tabOverview: 'Apžvalga',
      tabNetworks: 'Loginiai tinklai',
      tabSwitches: 'Switchai',
      overviewHint: 'Fabric vienu žvilgsniu: kiekvienas loginis tinklas su MTU ir potinkliu (VLAN gyvena tik prievadų ir LAGG atvaizdavimuose — tas pats tinklas skirtingais prievadais gali keliauti su skirtingomis žymomis). Fabric yra IŠORINĖS infrastruktūros registras — TVirt stebi ir deklaruoja, niekada nevykdo provisioning ir liečia tik jo kontrolei registruotas NIC.',
      absorptionHint: 'Kiekvienas čia deklaruotas potinklis tuo pačiu rašymu IŠVEDA savo įrašą IPAM registre — gyvena ir miršta kartu su tinklu.',
      scopeFixedHint: 'Scope fiksuotas klasterio šaknyje: fizinė infrastruktūra pagal apibrėžimą apima visą klasterį.',
      networksHint: 'Kiekvienas tinklas turi privalomą MTU (numatytoji 1500) ir privalomą potinklį; čia deklaruoti gateway, DNS serveriai ir statiniai maršrutai yra VIENINTELIS ŠALTINIS serverių NIC, programoms ir tinklo paslaugoms.',
      switchesHint: 'Rankinis registras: prievadas yra nenaudojamas, atvaizduotas (untagged srautas ir pagal VLAN žymą į loginius tinklus) arba LAGG narys — narys savų atvaizdavimų neturi.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Privaloma — IPAM iš jo automatiškai išveda registro įrašą',
      nodeAddressing: 'Mazgų adresavimas',
      nodeAddressingNone: 'Nėra — mazgui adresas neskiriamas',
      nodeAddressingPool: 'Pool — vienas pastovus adresas kiekvienam aptarnaujamam mazgui',
      nodeAddressingHint: 'Su Pool fabric išvedimas kiekvienam aptarnaujamam mazgui skiria adresą iš TVirt rezervuotų rėžių (paskyrus — pastovus).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Rezervuoti diapazonai',
      dns: 'DNS serveriai (atskirti kableliais)',
      dnsShort: 'DNS',
      singleSourceHint: 'Čia deklaruoti gateway, DNS ir maršrutai yra vienintelis šaltinis — serverių NIC, programos ir tinklo paslaugos semia iš čia',
      routesTitle: 'Statiniai maršrutai',
      routeDestination: 'Paskirtis (CIDR)',
      routeVia: 'Per (next hop)',
      portUsed: 'Naudojama',
      vlanMappings: 'VLAN atvaizdavimai',
      vlanTag: 'VLAN žyma',
      vlanNetwork: 'Loginis tinklas',
      nameTaken: 'Pavadinimas fabric viduje jau užimtas',
      addNetwork: 'Pridėti tinklą',
      editNetwork: 'Redaguoti tinklą',
      deleteNetwork: 'Šalinti tinklą',
      deleteNetworkConfirm: 'Pašalinti loginį tinklą {name} iš fabric? Jo išvestas potinklis IPAM registre mirs kartu su juo (atmetama, kol jį naudoja kokia nors paslauga ar programa). Į jį rodantys portų ir LAGG susiejimai išvalomi.',
      switchName: 'Switch',
      portName: 'Prievadas',
      positionHint: 'Fizinė padėtis (neprivaloma) — tas pats žodynas kaip serverių išdėstyme; tik deklaratyvi',
      addSwitch: 'Pridėti switch',
      editSwitch: 'Redaguoti switch',
      deleteSwitch: 'Šalinti switch',
      deleteSwitchConfirm: 'Pašalinti switch {name} su visais jo prievadais? LAGG atitinkamai susitraukia (ir miršta, likę su mažiau nei dviem prievadais).',
      addPort: 'Pridėti prievadą',
      editPort: 'Redaguoti prievadą',
      deletePort: 'Šalinti prievadą',
      deletePortConfirm: 'Pašalinti prievadą {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (žyma:tinklas)',
      taggedShort: 'Tagged',
      portCabling: 'Kabeliavimas',
      portState: 'Būsena',
      stateUnused: 'nenaudojama',
      stateMapped: 'atvaizduota',
      laggPortGuard: 'LAGG nariu esantis prievadas keičiamas LAGG pusėje',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG yra 2+ prievadai su LACP ir gali apimti kelis switch (MLAG, skaidriai); į jį patenka tik nenaudojami prievadai, LAGG yra atvaizdavimo paviršius, o pašalintas prievadas vėl tampa nenaudojamas.',
      addLagg: 'Pridėti LAGG',
      editLagg: 'Redaguoti LAGG',
      deleteLagg: 'Šalinti LAGG',
      deleteLaggConfirm: 'Pašalinti LAGG {name}? Jo nariais buvę prievadai vėl tampa nenaudojami.',
      lacpRate: 'LACP rate',
      laggPorts: 'Prievadai nariai (2+)',
      laggPortsHint: 'Patenka tik nenaudojami prievadai — pirma atlaisvinkite atvaizduotą prievadą',
      noNetworks: 'Nedeklaruotas nė vienas loginis tinklas.',
      noSwitches: 'Nedeklaruotas nė vienas switch.',
      noLaggs: 'Nedeklaruotas nė vienas LAGG.',
      staleConflict: 'Kitas operatorius pakeitė šį fabric, kol jį redagavai: išsaugojimas buvo atmestas, kad nebūtų ištrintas jo darbas. Tavo pakeitimai vis dar čia, nepaliesti. Atnaujintas fabric jau perkrautas: patvirtink dar kartą, kad juos pritaikytum ant viršaus, arba atšauk ir pažiūrėk, kas pasikeitė.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Tik išvestas: kiekvienas potinklis gimsta iš loginio fabric tinklo arba iš overlay — keičiamas šaltinyje. Priskirti adresai rodo, KAS juos laiko; TVirt rezervuoti diapazonai yra automatinio priskyrimo telkiniai.',
      search: 'Ieškoti pagal pavadinimą, CIDR arba adresą',
      empty: 'Tinklų nėra — deklaruokite loginį fabric tinklą arba overlay potinklį: IPAM automatiškai išvedamas iš jų.',
      reserved: 'TVirt rezervuoti diapazonai',
      address: 'Adresas',
      origin: 'Kilmė',
      origin_declared: 'deklaruota',
      origin_observed: 'stebėta',
      holder: 'Laiko',
      noAddresses: 'Šiame potinklyje žinomų adresų nėra.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Redaguoti šaltinyje'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Užkardos grupės',
      createTitle: 'Nauja užkardos grupė',
      editTitle: 'Redaguoti užkardos grupę',
      empty: 'Užkardos grupių dar nėra — sukurkite vieną: daugkartinio naudojimo taisyklių žodynas, į kurį svečių NIC nurodo vardu.',
      nameHint: 'Raidės, skaitmenys ir . - _ viduje; unikalus savo scope ribose (bendravardžius kitur atskiria /scope/vardas)',
      description: 'Aprašymas',
      descriptionHint: 'Viena ketinimo eilutė, rodoma visur, kur grupė pasirenkama',
      enforced: 'Primesta visam scope',
      enforcedHint: 'Išjungta: grynas žodynas — taisyklės saisto tik tas NIC, kurios nurodo grupę. Įjungta: taisyklės saisto kiekvieną svečio NIC su įjungta užkarda po grupės scope, nurodytą ar ne.',
      enforcedChip: 'Primesta',
      enforcedChipHint: 'Taisyklės saisto kiekvieną svečio NIC su įjungta užkarda po grupės scope, nurodytą ar ne',
      enforceWarning: 'Įjungus primetimą taisyklės per kitą suderinimą saistys KIEKVIENĄ svečio NIC su įjungta užkarda po {scope}, net be tiesioginės nuorodos — o aktyvios chain viduje protėvio drop yra galutinis: žemesni lygiai jo nebeatveria.',
      unenforceInfo: 'Nuėmus primetimą taisyklės lieka tik ant tų NIC, kurios grupę nurodo tiesiogiai.',
      rules: 'Taisyklės',
      tabOverview: 'Apžvalga',
      tabRules: 'Taisyklės',
      orderHint: 'Eilučių tvarka IR YRA vertinimo tvarka grupės viduje: laimi pirma atitikusi taisyklė.',
      statefulHint: 'Stateful yra numanomas: atsakymai į įleistą srautą praeina savaime (established/related priimami, invalid atmetamas — juos įterpia variklis, ranka jų niekas nerašo).',
      noRules: 'Taisyklių nėra — dar kuriamas žodynas: nurodyti jį leidžiama ir tai nieko nesugeneruoja.',
      addRule: 'Pridėti taisyklę',
      direction: 'Kryptis',
      directionIn: 'Įeinanti',
      directionOut: 'Išeinanti',
      action: 'Veiksmas',
      action_accept: 'Priimti',
      action_drop: 'Numesti',
      action_reject: 'Atmesti',
      protocol: 'Protokolas',
      protocolAny: 'Bet kuris',
      ports: 'Prievadai',
      source: 'Šaltinis',
      dest: 'Paskirtis',
      comment: 'Komentaras',
      addressHint: 'IPv4 CIDR arba <fabric>/<loginis tinklas>; tuščia = bet kuris',
      moveUp: 'Perkelti aukštyn',
      moveDown: 'Perkelti žemyn',
      nicFirewall: 'Užkarda',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Užkardos grupės',
      nicGroupsPlaceholder: 'Pasirinkite grupę…',
      nicGroupsHint: 'Matomos grupės, įskaitant aukštesnių scope grupes (naudojamos žemyn, kaip žymos)',
      nicGroupCount: { one: '{n} užkardos grupė', few: '{n} užkardos grupės', many: '{n} užkardos grupės', other: '{n} užkardos grupių' },
      nicOff: 'Užkarda išjungta',
      pendingRestartHint: 'Užkardos pakeitimai seka modeliu išsaugota/pritaikyta: jie laukia kito maitinimo ciklo (PendingRestart). Aukštesnių scope primestos grupės pritaikomos, kai NIC užkarda įjungta.',
      appConvergeHint: 'Užkardos pakeitimai pritaikomi per kitą konteinerio suderinimą. Aukštesnių scope primestos grupės pritaikomos, kai užkarda įjungta.',
      enforcedAncestors: 'Primestos aukštesnių scope',
      enforcedAncestorsHint: 'Ši grupė taikoma kiekvienai NIC po savo scope su ĮJUNGTA užkarda — jungiklis yra pagrindinis NIC jungiklis (išjungta = jokios chain, protėviai įskaitytinai); aktyvios chain viduje protėvio valdžia galutinė: jo drop žemiau nebeatveriamas.'
    }
  }
}
